<p-messages
  class="custom-popup"
  [closable]="true"
  [enableService]="false"
  *ngIf="showMessage && policyList.length > 0">
  <ng-template pTemplate="content">
    <div class="custom-popup flex rounded-lg p-2 border-l-[10px] border-primary_text ml-auto -mt-20 w-[80vh] -mb-36">
      <div class="text-sm flex justify-between w-full pr-2 md:items-baseline">
        <div class="mb-0 mr-2 flex items-center">
          <div
            class="flex-shrink-0 bg-primary_text text-white font-bold rounded-full w-5 h-5 flex items-center justify-center mr-2">
            <i class="pi pi-info text-xs text-white"></i>
          </div>
          <span class="font-app-regular">{{ message.detail }}</span>
        </div>
        <div class="flex items-baseline justify-center md:mt-2">
          <i class="pi pi-arrow-right mr-1 mb-3 text-xs text-gray-500"></i>
          <span
            class="font-app-bold cursor-pointer md:ml-0 text-blue-500 hover:underline"
            (click)="onReturnToDocument()">
            {{ "common.seeDocuments" | translate }}
          </span>
        </div>
        <button
          pButton
          (click)="closeMessage()"
          class="ml-2">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>
  </ng-template>
</p-messages>

